import type { IconProps } from './types';

export const CompareIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M11.0625 2.625H2.625V21.375H11.0625M13.875 2.625H21.375V21.375H13.875M11.0625 0.75V23.25"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
